import { IOperation } from '@/contracts/system-modules/sync/operation/IOperation'
import { IFoldTabs, ITabsState } from '@/contracts/modules/note/use-case/IFoldTabs'
import { EnumTabsEvent } from '@/contracts/modules/note/enum/EnumNoteEvent'

/** Состояние вкладок — последнее по метке tabs_changed; без событий вкладок нет */
export class FoldTabs implements IFoldTabs {
  exec(operations: IOperation[]): ITabsState {
    const last = operations
      .filter((operation) => operation.event === EnumTabsEvent.TABS_CHANGED)
      .sort((a, b) => (a.time < b.time ? -1 : a.time > b.time ? 1 : 0))
      .pop()
    if (last === undefined) {
      return { open: [], active: null }
    }
    const open = Array.isArray(last.fields.open)
      ? last.fields.open.filter((item): item is string => typeof item === 'string')
      : []
    const active = typeof last.fields.active === 'string' ? last.fields.active : null

    return { open, active }
  }
}
